<template>
  <div class="newbie-page">
    <div class="page-top">
      <img src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png" alt="" class="back-btn" @click="$router.back()" />
      新人专属福利
    </div>
    <div class="page-body">
      <div class="hero-card">
        <div class="hero-title">新人专属福利</div>
        <div class="hero-sub">完成实名认证后可申请领取，审核通过后到账，每位用户仅限一次</div>
        <div class="amount">¥ {{ amountText }}</div>
      </div>

      <div class="status-card">
        <div class="status-row">实名状态：{{ verified ? '已认证' : '未认证' }}</div>
        <div class="status-row">领取状态：{{ statusText }}</div>
      </div>

      <button
        v-if="canClaim"
        class="claim-btn"
        type="button"
        :disabled="claiming"
        @click="claim"
      >
        {{ claiming ? '提交中...' : '申请领取' }}
      </button>
      <div v-else-if="pending" class="claimed-tip pending-tip">申请已提交，请等待审核</div>
      <div v-else-if="claimed" class="claimed-tip">您已成功领取新人彩金</div>
      <div v-else-if="rejected" class="claimed-tip rejected-tip">申请已被拒绝，无法再次领取</div>
      <div v-else-if="!verified" class="claimed-tip pending-tip">请先完成实名认证</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newbieBonus',
  data() {
    return {
      amount: 0,
      verified: false,
      status: -1,
      statusText: '未领取',
      claimed: false,
      pending: false,
      rejected: false,
      canClaim: false,
      claiming: false
    };
  },
  computed: {
    amountText() {
      const n = parseFloat(this.amount);
      return Number.isFinite(n) ? n.toFixed(2) : '0.00';
    }
  },
  created() {
    this.bootstrap();
  },
  methods: {
    applyStatus(data) {
      this.amount = data.amount || 0;
      this.verified = !!data.verified;
      this.status = typeof data.status === 'number' ? data.status : -1;
      this.statusText = data.status_text || '未领取';
      this.claimed = !!data.claimed || this.status === 1;
      this.pending = !!data.pending || this.status === 0;
      this.rejected = !!data.rejected || this.status === 2;
      this.canClaim = !!data.can_claim;
    },
    bootstrap() {
      const that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/realname-status', {}).then(res => {
        if (res.code !== 200) {
          that.$parent.hideLoading();
          that.$parent.showTost(0, res.message || '加载失败');
          return;
        }
        that.verified = !!res.data.verified;
        if (!that.verified) {
          that.$parent.hideLoading();
          that.$dialog.confirm({
            title: '提示',
            message: '领取新人彩金前需完成实名认证',
            confirmButtonText: '去实名',
            cancelButtonText: '取消'
          }).then(() => {
            that.$parent.goNav('/realnameAuth');
          }).catch(() => {
            that.$router.back();
          });
          return;
        }
        that.loadBonus();
      }).catch(() => {
        that.$parent.hideLoading();
        that.$parent.showTost(0, '网络异常');
      });
    },
    loadBonus() {
      const that = this;
      that.$apiFun.post('/api/newbie-bonus', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message || '加载失败');
          return;
        }
        that.applyStatus(res.data || {});
      }).catch(() => {
        that.$parent.hideLoading();
        that.$parent.showTost(0, '网络异常');
      });
    },
    claim() {
      const that = this;
      if (!that.verified) {
        that.$dialog.confirm({
          title: '提示',
          message: '领取新人彩金前需完成实名认证',
          confirmButtonText: '去实名',
          cancelButtonText: '取消'
        }).then(() => {
          that.$parent.goNav('/realnameAuth');
        }).catch(() => {});
        return;
      }
      that.claiming = true;
      that.$parent.showLoading();
      that.$apiFun.post('/api/claim-newbie-bonus', {}).then(res => {
        that.claiming = false;
        that.$parent.hideLoading();
        if (res.code !== 200) {
          if (res.data && res.data.need_realname) {
            that.$dialog.confirm({
              title: '提示',
              message: res.message || '请先完成实名认证',
              confirmButtonText: '去实名',
              cancelButtonText: '取消'
            }).then(() => {
              that.$parent.goNav('/realnameAuth');
            }).catch(() => {});
            return;
          }
          that.$parent.showTost(0, res.message || '申请失败');
          that.loadBonus();
          return;
        }
        that.applyStatus(Object.assign({
          verified: true,
          amount: that.amount,
          status: 0,
          status_text: '审核中',
          pending: true,
          claimed: false,
          rejected: false,
          can_claim: false
        }, res.data || {}));
        that.$parent.showTost(1, res.message || '申请已提交，请等待审核');
      }).catch(() => {
        that.claiming = false;
        that.$parent.hideLoading();
        that.$parent.showTost(0, '网络异常');
      });
    }
  }
};
</script>

<style scoped>
.newbie-page {
  min-height: 100vh;
  background: #0b0f1a;
  color: #fff;
}
.page-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background: #12203a;
  z-index: 1000;
}
.back-btn {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  filter: brightness(10);
}
.page-body {
  padding: 70px 16px 30px;
}
.hero-card {
  background: linear-gradient(135deg, #1a2b4d, #0f1729);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 14px;
  padding: 22px 18px;
  text-align: center;
}
.hero-title {
  font-size: 20px;
  font-weight: 700;
}
.hero-sub {
  margin-top: 8px;
  font-size: 13px;
  color: #9aa4b8;
}
.amount {
  margin-top: 18px;
  font-size: 36px;
  font-weight: 700;
  color: #ffd56a;
}
.status-card {
  margin-top: 16px;
  background: rgba(255,255,255,0.04);
  border-radius: 12px;
  padding: 14px 16px;
}
.status-row {
  font-size: 14px;
  line-height: 1.9;
  color: #d7deea;
}
.claim-btn {
  margin-top: 24px;
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: linear-gradient(90deg, #2f6bff, #1e4fd6);
  color: #fff;
  font-size: 16px;
}
.claim-btn:disabled {
  opacity: 0.6;
}
.claimed-tip {
  margin-top: 24px;
  text-align: center;
  color: #8fd39a;
  font-size: 15px;
}
.pending-tip {
  color: #ffd56a;
}
.rejected-tip {
  color: #ff8f8f;
}
</style>



// WEBPACK FOOTER //
// src/components/newbieBonus.vue